'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getElementDisplayName = exports.clearRegistry = exports.getElementTypeObjects = exports.getElementTypes = exports.getElementToStringFn = exports.getElementExportComponent = exports.getElementTooltip = exports.getElementPresentationalComponent = exports.getElementContainerComponent = exports.getElementTools = exports.createElementObject = exports.registerElementType = exports.isElementTypeValid = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash');

var _ElementExportFallback = require('./ElementExportFallback');

var _ElementExportFallback2 = _interopRequireDefault(_ElementExportFallback);

var _elementExportStringFallback = require('./elementExportStringFallback');

var _elementExportStringFallback2 = _interopRequireDefault(_elementExportStringFallback);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* FIXME This is using a singleton object, this makes it difficult to test and is the reason for the 'clearRegistry'
         method below.  Find out a way to avoid this sort of object. */
var elementTypeObjects = {};

/**
 * Retrieves the element type from the elementTypes map, or throws an exception if it doesn't exist.
 *
 * @param elementType
 * @returns {*}
 */
var getElementTypeObject = function getElementTypeObject(elementType) {
    var elementTypeObj = elementTypeObjects[elementType];
    if (!elementTypeObj) console.error('Unknown element type: ' + elementType);
    return elementTypeObj;
};

var isElementTypeValid = exports.isElementTypeValid = function isElementTypeValid(elementType) {
    return (0, _lodash.isObject)(elementTypeObjects[elementType]);
};

var registerElementType = exports.registerElementType = function registerElementType(_ref) {
    var elementType = _ref.elementType,
        displayName = _ref.displayName,
        objectConstructorFn = _ref.objectConstructorFn,
        containerComponent = _ref.containerComponent,
        presentationalComponent = _ref.presentationalComponent,
        exportComponent = _ref.exportComponent,
        toStringFn = _ref.toStringFn,
        tools = _ref.tools,
        _ref$showTool = _ref.showTool,
        showTool = _ref$showTool === undefined ? true : _ref$showTool;

    var elementTypeObj = elementTypeObjects[elementType] || {};

    elementTypeObjects[elementType] = _extends({}, elementTypeObj, {
        elementType: elementType,
        displayName: displayName,
        objectConstructorFn: objectConstructorFn,
        containerComponent: containerComponent,
        presentationalComponent: presentationalComponent,
        exportComponent: exportComponent,
        toStringFn: toStringFn,
        tools: tools,
        showTool: showTool
    });
};

var createElementObject = exports.createElementObject = function createElementObject(action) {
    var elementType = getElementTypeObject(action.elementType);
    return elementType.objectConstructorFn(action);
};

var getElementTools = exports.getElementTools = function getElementTools(elementType) {
    return getElementTypeObject(elementType) && getElementTypeObject(elementType).tools;
};

var getElementContainerComponent = exports.getElementContainerComponent = function getElementContainerComponent(elementType) {
    return getElementTypeObject(elementType) && getElementTypeObject(elementType).containerComponent;
};

var getElementPresentationalComponent = exports.getElementPresentationalComponent = function getElementPresentationalComponent(elementType) {
    return getElementTypeObject(elementType) && getElementTypeObject(elementType).presentationalComponent;
};

var getElementTooltip = exports.getElementTooltip = function getElementTooltip(elementType) {
    return getElementTypeObject(elementType) && getElementTypeObject(elementType).tooltip || '';
};

var getElementExportComponent = exports.getElementExportComponent = function getElementExportComponent(elementType) {
    return getElementTypeObject(elementType) && getElementTypeObject(elementType).exportComponent || _ElementExportFallback2.default;
};

var getElementToStringFn = exports.getElementToStringFn = function getElementToStringFn(elementType) {
    return getElementTypeObject(elementType) && getElementTypeObject(elementType).toStringFn || _elementExportStringFallback2.default;
};

var getElementTypes = exports.getElementTypes = function getElementTypes() {
    return Object.keys(elementTypeObjects);
};
var getElementTypeObjects = exports.getElementTypeObjects = function getElementTypeObjects() {
    return elementTypeObjects;
};

var clearRegistry = exports.clearRegistry = function clearRegistry() {
    elementTypeObjects = {};
};

var getElementDisplayName = exports.getElementDisplayName = function getElementDisplayName(elementType) {
    return getElementTypeObject(elementType) && getElementTypeObject(elementType).displayName;
};


//////////////////
// WEBPACK FOOTER
// ./src/common/elements/elementRegistry.js
// module id = 56
// module chunks = 0